import {resetALL} from "../../../../../.globals/redux/actions";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit"
import {clientQuery} from '../../../../../core/data/GraphQLApi';
import {endpoints} from '../../../../../core/defaultValues';
import { updateDriverCaseAccountConfig } from '../widgets/coachingEducation/redux/slice';

const route = "modules/driverPerformance/views/functionTab/redux/slice";

const INIT_STATE = {
    loadingConfigs: false,
    configs: []
};

export const searchDriverCaseAccountConfigs = createAsyncThunk(
    "driverPerformance/functionTab/searchDriverCaseAccountConfig",
    async (payload, { rejectWithValue, getState }) => {
        try {
            const response = await clientQuery(
                `
                query searchDriverCaseAccountConfig ($configType: String, $limit: Int, $offset: Int) {
                    data: searchDriverCaseAccountConfig (configType: $configType, limit: $limit, offset: $offset) {
                        total
                        items {
                            id
                            configType
                            configEnable
                            jsonValues
                            autoCurateExecutedOn 
                        }
                    }
                }`,
                {
                    offset: 0,
                    limit: 20
                },
                endpoints.GRAPHQL_GENERAL_V2
            );

            return response?.data || { items: [], total:  0 };

        } catch (exc) {
            return rejectWithValue(exc.message);
        }
    }
);


//Slice
const driverPerformanceFunctionTabRedux = createSlice({
    name: "driverPerformance/functionTab",
    initialState: INIT_STATE,
    reducers: {
        resetFunctionTab(state, action) {
            return action.payload ? { ...state, ...action.payload } : INIT_STATE;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetALL, () => INIT_STATE);

        //searchDriverCaseAccountConfigs
        builder.addCase(searchDriverCaseAccountConfigs.pending, (state, action) => {
            state.loadingConfigs = true;
        })
        builder.addCase(searchDriverCaseAccountConfigs.fulfilled, (state, action) => {
            state.loadingConfigs = false;
            state.configs = action.payload.items;
        })
        builder.addCase(searchDriverCaseAccountConfigs.rejected, (state, action) => {
            state.loadingConfigs = false;
            state.error = action.payload;
        })
        
        // Update config when CoachingEducation is updated
        builder.addCase(updateDriverCaseAccountConfig.fulfilled, (state, action) => {
            const coachingConfig = state.configs.find(c => c.configType === 'functions_coachingEducation');
            if (coachingConfig) {
                coachingConfig.configEnable = action.payload.isEnabled ? 1 : 0;
            } else {
                // If config doesn't exist (first time creation), add it to the array
                state.configs.push({
                    configType: 'functions_coachingEducation',
                    configEnable: action.payload.isEnabled ? 1 : 0,
                    jsonValues: null
                });
            }
        })
    },
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = driverPerformanceFunctionTabRedux;

// Extract and export each action creator by name
export const { resetFunctionTab } = actions;

// Export the reducer, either as a default or named export
export default reducer;
